/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  font-size: 0.0714285714rem;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  cursor: default;
  text-align: left;
  font-size: 0.8571428571rem;
  line-height: 1.2857142857rem;
}
:host .tag-slot {
  width: 100%;
}
:host ::slotted(davinci-tag) {
  margin: 0 0.8571428571rem 0.2857142857rem 0;
}
:host ::slotted(davinci-tag[type=filter]) {
  cursor: pointer;
}

:host([hidden]) {
  display: none;
}`;
export { style };
